import { Component } from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as wConst from "../consts/website-consts";

class PageListen extends Component {


  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action, other) => {
      this.props.dispatch(wActs.loadPage());
      //console.log(location); console.log(action); console.log(other);
      if(action=="PUSH") {
        if(location.pathname.indexOf("/links")<0 && location.search.indexOf("filter")<0) {
          if(typeof window !== "undefined") {
            setTimeout(() => {
              let yScr = window.scrollY;
              if(yScr>300) {
                const scrollToTop = () => {
                  const c = document.documentElement.scrollTop || document.body.scrollTop;
                  if (c > 0) {
                    window.requestAnimationFrame(scrollToTop);
                    window.scrollTo(0, c - c / 8);
                  }
                };
                scrollToTop();
              }
            },300);
          }
        }
      }



      if(action === "POP") {
        //console.log("POP", this.props.ShowingImages);
        if(this.props.ShowingImages) {
          this.props.dispatch({type: wConst.ACTION_HIDINGIMAGES, payload: false});
          return;
        }
      }
    });
  }
  componentWillUnmount() {
    this.unlisten();
  }
  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    ShowingImages: state.Website.ShowingImages,
    ShowingLogin: state.Website.ShowingLogin,
    ShowingRegister: state.Website.ShowingLogin,
    WebPage: state.Website
  };
}


export default withRouter(connect(mapStateToProps)(PageListen));
